import { ArrowUpRight, Hammer, GraduationCap } from "lucide-react";
import { Reveal } from "./Reveal";
import { bookService } from "./Nav";

export const Paths = () => (
    <section id="paths" data-testid="paths-section" className="py-24 md:py-32 border-t border-ink/10">
        <div className="mx-auto max-w-7xl px-5 md:px-10">
            <Reveal>
                <p className="flex items-center gap-3 text-xs md:text-sm tracking-[0.25em] uppercase text-ink/50">
                    <span className="h-px w-10 bg-worx inline-block" /> Two ways to work together
                </p>
                <h2 className="mt-6 font-display font-semibold tracking-tighter leading-[0.95] text-4xl md:text-6xl max-w-3xl">
                    Have it built — <span className="text-worx">or learn to build it.</span>
                </h2>
            </Reveal>
            <div className="mt-12 grid md:grid-cols-2 gap-px bg-ink/10 border border-ink/10">
                <Reveal>
                    <div className="bg-ink text-paper p-10 md:p-14 h-full flex flex-col" data-testid="path-dev">
                        <Hammer size={28} className="text-worx" />
                        <h3 className="mt-6 font-display font-medium tracking-tight text-3xl">I build it for you</h3>
                        <p className="mt-4 text-paper/60 leading-relaxed">
                            Custom websites, web applications, and CRM systems — designed, built, and launched
                            for your business. Every project starts with a free discovery call, in person or on
                            Google Meet, and you get a straight quote before any work begins.
                        </p>
                        <p className="mt-4 text-sm text-worx font-medium uppercase tracking-[0.15em]">Free discovery call · Custom-quoted</p>
                        <a
                            href="#booking"
                            onClick={bookService("web-dev")}
                            data-testid="path-dev-cta"
                            className="mt-auto pt-8 inline-flex items-center gap-2 bg-worx text-white px-6 py-3.5 font-medium hover:bg-paper hover:text-ink transition-colors duration-200 w-max"
                        >
                            Book a free dev consult <ArrowUpRight size={16} />
                        </a>
                    </div>
                </Reveal>
                <Reveal delay={0.08}>
                    <div className="bg-white p-10 md:p-14 h-full flex flex-col" data-testid="path-classes">
                        <GraduationCap size={28} className="text-worx" />
                        <h3 className="mt-6 font-display font-medium tracking-tight text-3xl">I teach you how</h3>
                        <p className="mt-4 text-ink/60 leading-relaxed">
                            One-on-one AI classes — social media content, workflow and email automation, or
                            building your own website. One focused hour, hands-on, in your tools and accounts.
                        </p>
                        <p className="mt-4 text-sm text-ink/50 font-medium uppercase tracking-[0.15em]">$95/hr prepaid · $100 after class</p>
                        <a
                            href="#booking"
                            onClick={bookService("social-content")}
                            data-testid="path-classes-cta"
                            className="mt-auto pt-8 inline-flex items-center gap-2 border border-ink px-6 py-3.5 font-medium hover:bg-ink hover:text-paper transition-colors duration-200 w-max"
                        >
                            Book a class <ArrowUpRight size={16} />
                        </a>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
